/**
 * /frontend/src/features/analytics/components/staffing/StaffEfficiencyChart.js
 */

import React from 'react';
import ChartContainer from '../shared/ChartContainer';
import HorizontalBarChart from '../charts/HorizontalBarChart';

/**
 * Staff/section efficiency chart.
 * @param {{data:Array<{entityName:string,customersServedPerHour:number}>}} props
 * @returns {JSX.Element}
 */
const StaffEfficiencyChart = ({ data }) => (
  <ChartContainer title="Efficiency" subtitle="Customers served per hour">
    <HorizontalBarChart data={data} xKey="entityName" yKey="customersServedPerHour" />
  </ChartContainer>
);

export default StaffEfficiencyChart;

